import { ReactComponent as DhlLogo } from '../../../../assets/dhl_logo.svg';

import { LogoContainer } from './style';

export const Logo = () => (
  <LogoContainer>
    <DhlLogo />
  </LogoContainer>
);
